import has from "lodash/fp/has";
import isEmpty from "lodash/fp/isEmpty";
import negate from "lodash/fp/negate";

import selectUserChoiceValues from "./selectUserChoiceValues";
import selectSelectedProduct from "./selectSelectedProduct";
import { shouldBeDisplayed } from "utils";

// removing fields that should no be rendered
function updateFields(userChoiceValues) {
  // subFields can exist at:
  //  1. field.props.fields
  //  2. field.fields
  //  3. field.options[n].fields - each option could have fields
  return (obj) => {
    if (has(["props", "fields"])(obj)) {
      return {
        ...obj,
        props: {
          ...obj.props,
          fields: obj.props.fields
            .filter(shouldBeDisplayed(userChoiceValues))
            .map(updateFields(userChoiceValues)),
        },
      };
    }

    if (has("fields")(obj)) {
      return {
        ...obj,
        fields: obj.fields
          .filter(shouldBeDisplayed(userChoiceValues))
          .map(updateFields(userChoiceValues)),
      };
    }

    if (has("options")(obj)) {
      return {
        ...obj,
        options: obj.options.map(updateFields(userChoiceValues)),
      };
    }

    return obj;
  };
}

const selectCustomisations = (state) => {
  const hasVolumentalData = !isEmpty(state.app.volumentalData);
  const userChoiceValues = selectUserChoiceValues(state);
  const selectedProduct = selectSelectedProduct(state);

  return selectedProduct?.customisations
    .filter(negate(has("preventRender")))
    .filter(shouldBeDisplayed(userChoiceValues))
    .filter(({ hideIfNoVolumentalData = false }) => {
      if (hideIfNoVolumentalData && !hasVolumentalData) {
        return false;
      }
      return true;
    })
    .map(updateFields(userChoiceValues));
};

export default selectCustomisations;
